import React from 'react'
import DefaultLayout from '@/layouts/Default'
import ArcadeNavigation from './ArcadeNavigation'
import { Season } from '@/features/arcade/types'
import { ISeo } from '@/components/Seo'

type Props = {
  seo: ISeo
  season?: Season
  navSeasonId?: number
  children?: React.ReactNode
}

export default function ArcadeLayout({
  seo,
  season,
  navSeasonId,
  children
}: Props) {
  return (
    <DefaultLayout
      seo={seo}
      headerConfiguration={{
        translucent: false,
        offset: { default: 0, md: 0 }
      }}
      footerConfiguration={{
        hasBorder: true,
        removeDefaultOffset: true
      }}
    >
      <ArcadeNavigation season={season} seasonId={navSeasonId} />
      {children}
    </DefaultLayout>
  )
}
